export default {
  case_db: '資料庫',
  case_title: '判案書標題',
  ap_remarks: '備註',
  srch_doctitle: '文件標題',
  srch_type: '類別',
  itemperpage: '每頁顯示結果',
}